import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { ConfirmPasswordDialogComponent } from '../../popup/confirm-password-dialog/confirm-password-dialog.component';

import { JsonObject } from '@angular-devkit/core';
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { CommonService } from "../../../_common/_service/user.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BeforePaymentConfirmDialogComponent } from '../../popup/beforepayment-confirm-dialog/beforepayment-confirm-dialog.component';

@Component({
  selector: 'app-international-mobile-recharge',
  templateUrl: './international-mobile-recharge.component.html',
  styleUrls: ['./international-mobile-recharge.component.scss']
})
export class InternationalMobileRechargeComponent implements OnInit {
  userorderdetailList: any;
  stringJson: any;
  stringObject: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  balance: any;
  ServiceName: any;
  cUser: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  FlatChargesByCountry: any;
  recentReceiver: any;
  show = 2;
  payIntMobileForm: FormGroup;
  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  isGet = true;


  countryList: any;
  productList: any;
  UsertBal: any;
  serviceCode: any;
  countryIsdcode: any;

  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  countryname: any;
  loadingspinner: boolean = false;
  operatorsList: any;
  AmountInUsd: any;
    opertorName: any;

  constructor(private authService: AuthService, private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute, private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService) {
    this.countryIsdcode = localStorage.getItem('countryIsdcode');
    //AccountCode == channel selected code
    //channel == channel selected name
    this.submitted = false;
    this.payIntMobileForm = this.fb.group({
      ISD: [null, [Validators.required]],
      PaymentModeCode: ["RRP"],
      Amount: [null, [Validators.required]],
      OperatorName: [null],
      //AccountCode: [null, [Validators.required]],
      mobileno: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(20), Validators.minLength(8)]],
      CountryIsdCode: [this.countryIsdcode],
      Channel: [null],

      Comment: [null],
      BeneficiaryName: [null, [Validators.pattern("^[a-zA-Z ]*$")]],

      amountInLocalCountry: [null],
      ChannelFrom: [null],
      AccountCodeFrom: [null],
      MobileNoFrom: [null],

      ServiceCode: [null],
      DeviceType: "web"

    })
  }

  ngOnInit() {

    this.token = this.tokenStorageService.getToken();
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.UsertBal = this.tokenStorageService.getUsertBal();
      this.GetdtoneCountryList();
      //this.getchannelList();
      //this.viewTransactions();


      // listen for search field value changes
      this.CountryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCountry();
        });

    }
    else {
      this._service.callMethodOfSecondComponent();
    }

  }
  get f() { return this.payIntMobileForm.controls; }

  Back() {

    this.router.navigate(['/Go-on']);
  }

  GetdtoneCountryList() {
    this.submitted = true;
  
    this.authService.GetdtoneCountryList().subscribe(response => {

      if (response) {
        this.countryList = response;
        // this.toastr.successToastr(response.Message, AppConstant.success);
      } else {
        this.toastr.error(response, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  getopertorbyCountry(val: any) {
    debugger
    this.countryCode = val.iso_code;
    this.countryname = val.name;
    this.GetdtoneoperatorsList(val.iso_code);
  }

  GetdtoneoperatorsList(val: any) {
    
    this.submitted = true;

    this.authService.GetdtoneoperatorsList(val).subscribe(response => {
      
      
      if (response) {
        this.operatorsList = response;
      } else {
        this.toastr.error(response, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {

        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  GetdtoneproductList(val: any) {
    this.submitted = true;
    this.opertorName = val.name;
    debugger
    this.authService.GetdtoneproductsList(val.id).subscribe(response => {
      debugger
      if (response) {
        this.productList = response;
        //  this.filteredBanks.next(this.countryList.slice());
        // this.toastr.successToastr(response.Message, AppConstant.success);
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      debugger
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }

    );
  }






  selectedProduct(data: any) {
    debugger
    //this.f.amountInLocalCountry.setValue(data.amountInLocalCountry);
    if (data.usdsourceamount == "") {
      this.commissionFee = 0;
      this.commissionTotal = 0;
      this.amt = 0;
    }

    else if (data.usdsourceamount) {

      if ((this.f.PaymentModeCode.value && this.serviceCode) && this.show != 1) {
        this.getServiceCommissionList(data.usdsourceamount, this.f.PaymentModeCode.value, this.serviceCode);
      }
      // for optin 1 popup :- AccountCodeFrom,form :- ServiceCode
      else if ((this.f.PaymentModeCode.value && this.serviceCode && this.f.AccountCodeFrom.value) && this.show == 1) {
        this.getServiceCommissionList(data.usdsourceamount, this.serviceCode, this.f.AccountCodeFrom.value);
      }
      else {
        this.toastr.error("Selected Proper Option", 'Error');
      }
      // Amount= ; AddService_Code=; PayService_Code= 
    }

  }
  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any) {

    //this.submitted = true;
    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode};
    this.authService.getServiceCommissionList(Amountrequested, SelectedrblOptionCode, SelectedNetworkCode, this.currentUser.serviceid).subscribe((response:
      { apiData: any; apiStatus: any; apiMessage: string | undefined; }) => {
      if (response.apiStatus == true) {

        this.commissionList = response.apiData;
        this.amt = Amountrequested;
        this.commissionFee = this.commissionList.totalCommission;
        this.commissionTotal = this.commissionList.totalAmount;

      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }



  //getIntMobProductsList() {
  //  this.submitted = true;
  //  this.loadingspinner = true;

  //  this.authService.getIntMobProductsList(this.f.ISD.value, this.f.mobileno.value, this.f.ServiceCode.value, this.currentUser.serviceid).subscribe(response => {
  //    debugger
  //    this.loadingspinner = false;
  //    if (response.apiStatus == true) {
  //      debugger;
  //      this.productList = response.apiData.productVoucherListAmounts;
  //      //this.f.amountInLocalCountry.setValue(response.apiData.productVoucherListAmounts[0].amountInLocalCountry);
  //      this.f.OperatorName.setValue(response.apiData.operttor);
  //      this.isGet = false;

  //    } else {
  //      this.toastr.error(response.apiMessage, 'Error');
  //    }

  //  }, (err: any) => {
  //    debugger
  //    if (err.error instanceof Error) {
  //      this.toastr.error(err.error, 'Error');
  //    } else {

  //      this.toastr.error(err.error, 'Error');
  //    }
  //  }
  //  );
  //}

  
  


  payIntMobile(post: any) {
    debugger
    this.submitted = true;
    //if (this.isGet == true) {
    //  this.getIntMobProductsList();
    //}
    //else
    if (post.Amount == null || post.Amount == 'undefined' || this.amt == null || this.amt == 'undefined') {

      this.toastr.error("Error", 'Error');

    }
    else {
      if (this.payIntMobileForm.valid) {
        this.loadingspinner = true;
        //AccountCode == channel selected code
        //channel == channel selected name

        var PayServicsReq = null;
        var AddServicsReq = null;
        if (this.show == 1) {
          //pop up 
          AddServicsReq = {
            Channel: post.ChannelFrom,
            Amount: parseFloat(post.Amount), MobileMoneySource: post.MobileNoFrom,
            AccountCode: post.AccountCodeFrom, CountryIsdCode: post.ISD

          }
          //form 
          PayServicsReq = {
            ISD: post.ISD,
            mobileNo: post.mobileno,

            AmountinUsd: parseFloat(post.Amount),
            AmountInLocalCountry: String(this.f.amountInLocalCountry.value),

            BeneficiaryName: post.BeneficiaryName,
            Comment: post.Comment,
            AccountCode: this.serviceCode
          }
        }
        else if (this.show == 2 || this.show == 3) {
          //pop up


          AddServicsReq = {
            Channel: post.Channel, //product_id
            Amount: parseFloat(post.Amount),
            AccountCode: post.PaymentModeCode
          }
          //form 
          PayServicsReq = {
            ISD: post.ISD,
            mobileNo: post.mobileno,
            AmountinUsd: parseFloat(post.Amount),
            AmountInLocalCountry: String(this.f.amountInLocalCountry.value),
            BeneficiaryName: post.BeneficiaryName,
            Comment: post.Comment,
            AccountCode: this.serviceCode
          }
        }

        //
        var post1 = {
          //form
          PayServicsReq: JSON.stringify(PayServicsReq),
          //popup
          AddServicsReq: JSON.stringify(AddServicsReq),
          ServiceCode: this.serviceCode,
          PaymentModeCode: post.PaymentModeCode,
          DeviceType: "web"
        }

        // Convert String obect to JSON
        this.stringJson = JSON.stringify(post1);
        console.log("String json object :", this.stringJson);

        //  // ConvertjSON to an object
        //  this.stringObject = JSON.parse(this.stringJson);
        //  ////////console.log("JSON object -", this.stringObject);

        this.authService.payIntMob(this.stringJson, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {

          this.loadingspinner = false;
          if (response.apiStatus == true && response.apiData.transactionStatus == 2) {
            this.data = response.apiData;
            ////////console.log("data succ response -", this.data);
            
            this.openPaymentConfirmDialog(this.data);
            this.payIntMobileForm.reset();


            this.submitted = false;

            this.commissionFee = 0;
            this.commissionTotal = 0;
            this.amt = 0;

            this.tokenService.updateMessagetoken('token'); //after payment succeful done then update userinfo& bal

          }
          //else if (response.apiStatus == true && response.apiData.transactionStatus != 2) {
          //  this.isGet = true;

          //  this.f.ChannelFrom.setValue(null);
          //  this.f.AccountCodeFrom.setValue(null);
          //  this.f.MobileNoFrom.setValue(null);

          //  this.f.Comment.setValue(null);
          //  this.f.BeneficiaryName.setValue(null);
          //  this.f.mobileno.setValue(null);
          //  this.f.ISD.setValue(null);
          //  this.f.OperatorName.setValue(null);
          //  this.f.Amount.setValue(null);
          //  this.submitted = false;

          //  this.commissionFee = 0;
          //  this.commissionTotal = 0;
          //  this.tokenService.updateMessagetoken('token');


          //  this.toastr.error(response.apiMessage, 'Error');
          //}

          else {
            this.payIntMobileForm.reset();
            this.submitted = false;

            this.commissionFee = 0;
            this.commissionTotal = 0;
            this.amt = 0;

            this.tokenService.updateMessagetoken('token'); //after payment succeful done then update userinfo& bal

            this.toastr.error(response.apiMessage, response.apiMessage);
          }
        }, (err: any) => {
          this.loadingspinner = false;
          if (err.error instanceof Error) {

            this.toastr.error(err.error, 'Error');
          } else {

            this.toastr.error(err.error, 'Error');
          }
        }
        );
      }
    }

  }

  openPaymentConfirmDialog(data: any) {
    const dialogRef = this.dialog.open(PaymentConfirmDialogComponent, {
      width: '350px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      window.location.reload();
    });

  }

  //selectedproductList(event: any) {

  //  this.AmountInUsd = parseFloat(event.usdsourceamount);




  //  //var CurrentBalance = parseFloat(this.cUser.CurrentBalance);

  //  //if (CurrentBalance >= this.AmountinXof) {
  //  //  this.calculateCommission();
  //  //}
  //  //else {
  //  //  this.toastr.errorToastr("You can not select this product.", AppConstant.error, { toastTimeout: 8000, maxShown: 1 });
  //  //  this.IntRechargeForm.reset();
  //  //  this.amtxof = null;
  //  //  this.commissionFee = 0;
  //  //  this.commissionTotal = 0;

  //  //  this.productList = null;
  //  //  this.operatorsList = null;
  //  //}
  //}

  filterCountry() {

    if (this.CountryFilterCtrl.value) {
      //

      return this.countryList.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.countryList;
    }
  }


  getchannelList() {
    this.submitted = false;

    this.authService.getchannelList(this.serviceCode, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {

      if (response.apiStatus == true) {
        this.OptionList = response.apiData;
        ////////console.log(this.OptionList);

      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  viewTransactions() {

    this.authService.getUserOrdersdetails1('IMR', this.currentUser.serviceid).subscribe(response => {
      if (response.apiStatus == true) {
        this.userorderdetailList = response.apiData;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }



  

  openDialog(post: any) {
    debugger
    this.submitted = true;
    //if (this.isGet == true) {
    //  this.getIntMobProductsList();
    //}
    //else
    
    this.f.Amount.setValue(this.commissionTotal);
    if (this.payIntMobileForm.valid) {
      post.serviceName = 'International Mobile Recharge';
      post.commissionFee = this.commissionFee;
      post.MobileMoneySource = this.f.mobileno.value;
      post.Amount = this.commissionTotal;
      post.beneficiary_country = this.countryname;
      post.beneficiary_phone = this.f.mobileno.value;
      post.OperatorName = this.opertorName;
      const dialogRef = this.dialog.open(BeforePaymentConfirmDialogComponent, {
        width: '450px',
        disableClose: true,
        hasBackdrop: true, // or false, depending on what you want
        autoFocus: false,
        maxHeight: '90vh', //you can adjust the value as per your view
        data: post
      });

      dialogRef.afterClosed().subscribe(result => {
        ;
        if (result !== undefined && result !== null && result) {
          this.payIntMobile(post);
        }
      });
    }


  }
}
